import { config } from '@/config';
import { deleteFranchise } from '@/api/admin';

export const routes = {
  CONSULTANT_ROUTES: {
    ROOT: 'consultants',
    FILTER: 'filter',
    UPDATE: ':id/update',
    MY_PROFILE: {
      GENERAL_INFO: 'general-info',
      CHANGE_PASSWORD: 'change-password',
      RATE_AND_PAYMENT: 'rate-and-payment',
      ACCOUNT_STATUS: 'account-status',
    },
  },
};

export const AdminRoute = {
  dashboard: `${config.VITE_BE_ADMIN_PREFIX}/dashboard`,
  payments: `${config.VITE_BE_ADMIN_PREFIX}/payments`,
  users: `${config.VITE_BE_ADMIN_PREFIX}/users`,
  franchises: `${config.VITE_BE_ADMIN_PREFIX}/franchises`,
  franchiseConsultantReviewsLatest: (id: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/franchises/${id}/consultant-reviews/latest`,
  franchiseConsultantReviews: (id: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/franchises/${id}/consultant-reviews`,
  updateUser: (id: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/users/${id}`,
  deleteUser: (id: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/users/${id}`,
  updateFranchise: (id: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/franchises/${id}`,
  // TCX-843: dedicated dismiss action for a pending upgrade request (not an
  // updateFranchise field — the backend clears the request fields as a set).
  dismissUpgradeRequest: (id: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/franchises/${id}/upgrade-request/dismiss`,
  deleteFranchise: (id: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/franchises/${id}`,
  dashboardGraph: `${config.VITE_BE_ADMIN_PREFIX}/dashboard-graph`,
  downloadPayment: `${config.VITE_BE_ADMIN_PREFIX}/payments/download`,
  downloadBookings: `${config.VITE_BE_ADMIN_PREFIX}/bookings/download`,
  downloadSessions: `${config.VITE_BE_ADMIN_PREFIX}/sessions/download`,
  downloadFranchises: `${config.VITE_BE_ADMIN_PREFIX}/franchises/download`,
  downloadCompanyBrands: `${config.VITE_BE_ADMIN_PREFIX}/brand-names/download`,
  downloadBrandMappings: `${config.VITE_BE_ADMIN_PREFIX}/brand-mappings/download`,
  downloadConsultants: `${config.VITE_BE_ADMIN_PREFIX}/consultants/download`,
  downloadReferences: `${config.VITE_BE_ADMIN_PREFIX}/references/download`,
  downloadFranchiseReviews: (id: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/franchises/${id}/consultant-reviews/download`,
  brandNames: `${config.VITE_BE_ADMIN_PREFIX}/brand-names`,
  updateBrandNames: (id: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/brand-names/${id}`,
  franchisors: `${config.VITE_BE_ADMIN_PREFIX}/franchisors`,
  addMemberFranchisor: ({
    franchisorId,
    franchiseId,
  }: {
    franchiseId: string;
    franchisorId: string;
  }) =>
    `${config.VITE_BE_ADMIN_PREFIX}/franchisors/${franchisorId}/add/${franchiseId}`,
  emailMgmtConsultants: `${config.VITE_BE_ADMIN_PREFIX}/email-management/consultants`,
  emailMgmtFranchisors: `${config.VITE_BE_ADMIN_PREFIX}/email-management/franchisors`,
  emailMgmtUserSync: (id: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/email-management/users/${id}/mailgun-sync`,
  emailMgmtBrandSync: (id: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/email-management/franchises/${id}/mailgun-sync`,
  emailMgmtConsultantsDownload: `${config.VITE_BE_ADMIN_PREFIX}/email-management/consultants/download`,
  emailMgmtFranchisorsDownload: `${config.VITE_BE_ADMIN_PREFIX}/email-management/franchisors/download`,
  groups: `${config.VITE_BE_ADMIN_PREFIX}/groups`,
  updateGroup: (id: string) => `${config.VITE_BE_ADMIN_PREFIX}/groups/${id}`,
  deleteGroup: (id: string) => `${config.VITE_BE_ADMIN_PREFIX}/groups/${id}`,
  // TCX-903 Free Listing Management.
  freeListingRequests: `${config.VITE_BE_ADMIN_PREFIX}/free-listing/requests`,
  freeListingStats: `${config.VITE_BE_ADMIN_PREFIX}/free-listing/stats`,
  freeListingRespond: (cardId: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/free-listing/requests/${cardId}/respond`,
  freeListingReply: (chatId: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/free-listing/threads/${chatId}/messages`,
  freeListingThread: (chatId: string) =>
    `${config.VITE_BE_ADMIN_PREFIX}/free-listing/threads/${chatId}`,
};
